module.exports = __webpack_public_path__ + "static/img/TR.64b743c2.png";